import { Group } from 'fabric';
import { readGroupCollection } from './read-group-collection';
import { arrangeEquispaced } from './arrange-equispaced';
import { arrangeGrid } from './arrange-grid';

export function arrangeGroup(group: Group): void {
  const cfg = readGroupCollection(group);
  if (!cfg) return;

  if (cfg.type === 'grid') {
    arrangeGrid(group, cfg);
  } else {
    arrangeEquispaced(group, cfg);
  }

  group.set('dirty', true);
  group.setCoords();
}
